module.exports = __webpack_public_path__ + "media/components/shared/static/twitter-f08dc474901c53598ba428d75a3745d4.svg";